export const replaceIdPath = (path: string, id: string | number): string => {
  return path.replace(/(?::id)/g, id.toString())
}
